<template>
	<el-popover
		v-model="visible"
		popper-class="chat-quick-actions-popper"
		placement="bottom-end"
		trigger="click"
		width="168"
	>
		<div class="chat-quick-actions">
			<button
				type="button"
				class="quick-action-item"
				@click="onSelect('add-friend')"
			>
				<i class="el-icon-user"></i>
				<span>添加好友</span>
			</button>
			<button
				v-if="canCreateGroup"
				type="button"
				class="quick-action-item"
				@click="onSelect('create-group')"
			>
				<i class="el-icon-s-custom"></i>
				<span>创建群聊</span>
			</button>
		</div>
		<button slot="reference" type="button" class="quick-action-trigger im-header-icon-btn" title="添加好友或创建群聊">
			<i class="el-icon-plus"></i>
		</button>
	</el-popover>
</template>

<script>
export default {
	name: "chatQuickActions",
	props: {
		canCreateGroup: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			visible: false
		};
	},
	methods: {
		onSelect(action) {
			this.visible = false;
			this.$emit('select', action);
		},
		close() {
			this.visible = false;
		}
	}
}
</script>

<style lang="scss">
.chat-quick-actions-popper {
	padding: 6px !important;
	border-radius: 12px !important;
	border: 1px solid rgba(var(--im-black-rgb), 0.08) !important;
	box-shadow: 0 12px 32px rgba(var(--im-black-rgb), 0.12) !important;
	min-width: 148px;
}

.chat-quick-actions {
	display: flex;
	flex-direction: column;
	gap: 4px;

	.quick-action-item {
		display: flex;
		align-items: center;
		gap: 8px;
		width: 100%;
		padding: 10px 12px;
		border: none;
		border-radius: 10px;
		background: transparent;
		color: var(--im-text-color);
		font-size: 13px;
		line-height: 1;
		cursor: pointer;
		text-align: left;
		transition: background-color 0.2s ease, color 0.2s ease;

		i {
			font-size: 14px;
			color: var(--im-color-primary);
		}

		&:hover {
			background: rgba(var(--im-primary-rgb), 0.08);
		}
	}
}

.quick-action-trigger {
	appearance: none;
	width: 36px;
	height: 36px;
	min-width: 36px;
	border-radius: 10px;

	i {
		font-size: 16px;
		line-height: 1;
		transform: translateY(0);
	}
}
</style>
